import React, { useEffect } from "react";

function SessionWrapper() {
  useEffect(() => {
    const retrieveUserObject = () => {
      try {
        const storedUserObject = localStorage.getItem("userObject");
        return storedUserObject ? JSON.parse(storedUserObject) : null;
      } catch (error) {
        console.log("Error accessing localStorage:", error);
        return null;
      }
    };

    const userObject = retrieveUserObject();

    const formattedUserObject = {
      phone: userObject?.phone || null,
      email: userObject?.email || null,
    };

    window.parent.postMessage({ userInfo: formattedUserObject, topic: "PRAGMA" }, "*");

    const handleParentMessage = (event) => {
      const receivedUserObject = event.data;
      if (receivedUserObject && receivedUserObject.topic === "PRAGMA") {
        localStorage.setItem("userObject", JSON.stringify(receivedUserObject));
      }
    };

    window.addEventListener("message", handleParentMessage);

    return () => {
      window.removeEventListener("message", handleParentMessage);
    };
  }, []);

  return <div></div>;
}
export default SessionWrapper;